/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/style-prop-object */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/no-array-index-key */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { store } from 'redux/store';
import { State } from 'redux/initialState';
import { SocietyCorporateId } from 'types/Society';

import { setModal } from 'modules/_shared/redux/modalActions';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import { getPartnerBook } from 'modules/partners/redux/partnerBookActions';
import { useGetOperations } from 'modules/transactions/hooks/useGetOperations';
import { getHoldingClasses } from 'modules/partners/redux/holdingClassActions';
import { configsByCorporateId } from 'modules/_custom/config/configsByCorporateId';
import DownloadPartnerBookModal from 'modules/partners/modals/DownloadPartnerBookModal';
import { operationsPartnerBook } from 'modules/transactions/constants/operationsPartnerBook';
import { DownloadPartnerBookModalProvider } from 'modules/partners/modals/DownloadPartnerBookModal/context/DownloadPartnerBookModalContext';
import DownloadLanguageModal from 'modules/partners/modals/DownloadLanguageModal';

import menuTypes from 'constants/menuTypes';

import { useTranslate } from 'hooks/useTranslate';
import { useGetActualSociety } from 'hooks/useGetActualSociety';

import { MAX_PARTNERS_BY_PARTNER_BOOK } from 'constants/defaultConstants';
import { useGetPartners } from 'modules/partners/hooks/useGetPartners';
import views from '../constants/views';
import viewOptions from '../utils/viewOptions';
import menuOptions from '../../PartnerList/utils/menuOptions';
import { getPartnersPercentages } from '../utils/getPartnersPercentages';
import { getHistoryTransactions } from '../utils/getHistoryTransactions';
import { getButtonId } from '../utils/getButtonId';
import { getSharesByPartner } from '../utils/getSharesByPartner';
import { PartnerBookPartnersRegister } from '../types/PartnerBook';
import { buildPartnersRegister } from '../utils/buildPartnersRegister';
import { buildPartnerBook } from '../utils/buildPartnerBook';

interface UsePartnerBookProps {
  updatedPartners?: any[];
  summaryRow?: any;
  draftView?: boolean;
  convertibleNoteView?: boolean;
  capitalizedNote?: boolean;
  buySellDraft?: boolean;
  isAdmin?: boolean;
  isReadOnly?: boolean;
}

export const usePartnerBook = ({
  updatedPartners,
  summaryRow,
  draftView,
  convertibleNoteView: _convertibleNoteView,
  capitalizedNote,
  buySellDraft,
  isAdmin,
  isReadOnly,
}: UsePartnerBookProps) => {
  const { i18n } = useTranslate();
  const dispatch = useDispatch();
  const { societyId } = useParams<{ societyId: string }>();
  const partnerBookFetchedRef = useRef<string | null>(null);

  useGetOperations({
    societyId,
    page: 1,
    rowsPerPage: 1000,
    filters: operationsPartnerBook,
  });

  useGetPartners({
    societyId,
    partnerId: '',
    categoryId: '',
    page: 1,
    items: MAX_PARTNERS_BY_PARTNER_BOOK,
  });

  const user = useSelector((state: State) => state?.user);
  const operations = useSelector((state: State) => state?.operations);
  const partnerBook = useSelector((state: State) =>
    state?.partnerBook?.societyId === societyId ? state?.partnerBook : null
  );
  const actualSociety = useSelector(
    (state: State) => state?.society?.actualSociety
  );
  const plans = useSelector((state: State) => state?.plans);
  const partners = useSelector((state: State) => state?.partners);
  const holdingClasses = useSelector((state: State) => state?.holdingClasses);

  const [bookDates, setBookDates] = useState<any>([]);
  const [bookColumns, setBookColumns] = useState<any>([]);
  const [bookHeaders, setBookHeaders] = useState<any>([]);
  const [bookComments, setBookComments] = useState<any>([]);
  const [bookPartners, setBookPartners] = useState<any>([]);
  const [bookOperations, setBookOperations] = useState<any>([]);
  const [bookTotals, setBookTotals] = useState<any>([]);
  const [bookTotalPartners, setBookTotalPartners] = useState<
    number | undefined
  >();
  const [bookOrder, setBookOrder] = useState<any>([]);
  const [bookDocuments, setBookDocuments] = useState<any>([]);

  const [isLoadingPartnersRegister, setIsLoadingPartnersRegister] =
    useState(false);
  const [isLoadingPartnerBook, setIsLoadingPartnerBook] = useState(false);

  const [partnersRegister, setPartnersRegister] =
    useState<PartnerBookPartnersRegister>();
  const [holdingClassNames, setHoldingClassNames] = useState<any>();
  const [view, setView] = useState<number>(
    isAdmin ? views.EQUITY_STORY : views.SUMMARY
  );
  const [filtredMenuOptions, setFiltredMenuOptions] = useState<any>([]);
  const [currentMenuOptions, setCurrentMenuOptions] = useState<any>(
    menuOptions(i18n, user, isAdmin)
  );

  const [currentViewOptions, setCurrentViewOptions] = useState<any>(
    viewOptions(i18n)
  );

  const isPartnerBookVisible = useMemo(() => {
    const config =
      configsByCorporateId[
        (actualSociety?.corporateId ||
          SocietyCorporateId.DEFAULT) as keyof typeof configsByCorporateId
      ];

    const { hasPartnerBookEnabled, maxPartnerBookRows } = config;

    if (!partners?.length) {
      return false;
    }

    const shouldShowPartnerBook =
      hasPartnerBookEnabled ||
      (!hasPartnerBookEnabled && partners.length <= maxPartnerBookRows);

    return isAdmin && shouldShowPartnerBook;
  }, [isAdmin, actualSociety, partners]);

  const needsPartnerBookData =
    view === views.EQUITY_STORY || Boolean(updatedPartners?.length);
  const needsPartnersRegister = view === views.COMMERCIAL_REGISTER;
  const needsHoldingClasses =
    view === views.COMMERCIAL_REGISTER ||
    view === views.SUMMARY ||
    view === views.SUMMARY_ACCUMULATED ||
    view === views.SUMMARY_INVESTORS;

  const handleExportEquityStory = async () => {
    if (!partnerBook && societyId && isPartnerBookVisible) {
      setIsLoadingPartnerBook(true);
      try {
        await dispatch(getPartnerBook(societyId));
        partnerBookFetchedRef.current = societyId;
      } finally {
        setIsLoadingPartnerBook(false);
      }
    }

    dispatch(
      setModal(
        // @ts-ignore
        React.createElement(
          DownloadPartnerBookModalProvider,
          null,
          // @ts-ignore
          React.createElement(DownloadPartnerBookModal, null)
        )
      )
    );
  };

  const handleExportTable = () => {
    if (view === views.EQUITY_STORY) {
      handleExportEquityStory();
    } else {
      const buttonId = getButtonId({
        view,
        partners,
        plans,
        holdingClasses,
        partnersRegister: partnersRegister || {},
      });
      // @ts-ignore
      store.dispatch(
        setModal(
          /* @ts-ignore */ React.createElement(DownloadLanguageModal, {
            buttonId,
          })
        )
      );
    }
  };

  const getSharesFromPartners = useCallback(
    async (partnerIds: string[], societyId: string) =>
      getSharesByPartner(partnerIds, societyId),
    []
  );

  useGetActualSociety(societyId);
  useGetMenu(draftView ? menuTypes.EXTENDED : menuTypes.NULL);

  useEffect(() => {
    const loadPartnersRegister = async () => {
      if (!isPartnerBookVisible || !needsPartnersRegister) {
        setPartnersRegister(undefined);
        setIsLoadingPartnersRegister(false);
        return;
      }

      setIsLoadingPartnersRegister(true);
      try {
        const currentPartnersRegister = await buildPartnersRegister({
          partners,
          actualSociety,
          operations,
          holdingClassNames,
        });
        setPartnersRegister(currentPartnersRegister || {});
      } catch (error) {
        console.error('Error building partners register:', error); // eslint-disable-line no-console
        setPartnersRegister({});
      } finally {
        setIsLoadingPartnersRegister(false);
      }
    };

    loadPartnersRegister();
  }, [
    partners,
    actualSociety,
    operations,
    holdingClassNames,
    isPartnerBookVisible,
    needsPartnersRegister,
  ]);

  // Effects
  useEffect(() => {
    if (draftView) {
      setView(views.SUMMARY);
    }
  }, [draftView]);

  useEffect(() => {
    if (!partners?.length) {
      setFiltredMenuOptions([currentMenuOptions[0]]);
    } else if (!actualSociety?.shares?.length) {
      setFiltredMenuOptions([currentMenuOptions[0], currentMenuOptions[1]]);
    } else {
      const options = currentMenuOptions.filter(
        (option: any, index: number) => index !== 1
      );
      setFiltredMenuOptions(options);
    }
  }, [actualSociety, societyId, currentMenuOptions, partners]);

  useEffect(() => {
    partnerBookFetchedRef.current = null;
  }, [societyId]);

  useEffect(() => {
    const loadPartnerBook = async () => {
      if (!isPartnerBookVisible || !societyId || !needsPartnerBookData) {
        return;
      }

      if (partnerBook?.societyId === societyId) {
        partnerBookFetchedRef.current = societyId;
        return;
      }

      if (partnerBookFetchedRef.current === societyId) {
        return;
      }

      setIsLoadingPartnerBook(true);
      try {
        await dispatch(getPartnerBook(societyId));
        partnerBookFetchedRef.current = societyId;
      } finally {
        setIsLoadingPartnerBook(false);
      }
    };

    loadPartnerBook();
  }, [
    isPartnerBookVisible,
    societyId,
    needsPartnerBookData,
    partnerBook?.societyId,
    dispatch,
  ]);

  useEffect(() => {
    if (isPartnerBookVisible && societyId && needsHoldingClasses) {
      dispatch(getHoldingClasses({ societyId }));
    }
  }, [isPartnerBookVisible, societyId, needsHoldingClasses, dispatch]);

  useEffect(() => {
    if (!partnerBook) {
      return;
    }

    setBookDocuments(partnerBook.documents);
  }, [partnerBook]);

  useEffect(() => {
    const result = buildPartnerBook({
      partnerBook: partnerBook as any,
      updatedPartners,
      summaryRow,
      buySellDraft,
      capitalizedNote,
    });

    if (result) {
      setBookOperations(result.bookOperations);
      setBookHeaders(result.bookHeaders);
      setBookComments(result.bookComments);
      setBookDates(result.bookDates);
      setBookColumns(result.bookColumns);
      setBookTotals(result.bookTotals);
      setBookOrder(result.bookOrder);
      setBookPartners(result.bookPartners);
      setBookTotalPartners(result.bookTotalPartners);
      return;
    }

    if (partnerBook) {
      setBookDates(partnerBook.dates);
      setBookColumns(partnerBook.columns);
      setBookHeaders(partnerBook.headers);
      setBookComments(partnerBook.comments);
      setBookPartners([]);
      setBookOperations(partnerBook.operations);
      setBookTotals(partnerBook.totals);
      setBookOrder(partnerBook.order);
      setBookTotalPartners(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerBook, updatedPartners, summaryRow]);

  useEffect(() => {
    if (holdingClasses?.length) {
      const names = holdingClasses?.reduce((acc: any, curr: any) => {
        acc[curr?.['_id']] = curr?.name;
        return acc;
      }, {});
      setHoldingClassNames(names);
    }
  }, [holdingClasses]);

  useEffect(() => {
    setCurrentMenuOptions(menuOptions(i18n, user, isAdmin));
    setCurrentViewOptions(
      !draftView
        ? viewOptions(i18n)
        : viewOptions(i18n).filter(
            (option: any) => option.name !== 'commercial'
          )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, user]);

  const isLoading = !actualSociety;
  const isError = false; // Add error handling logic if needed

  return {
    data: {
      actualSociety,
      partnerBook,
      partners,
      operations,
      plans,
      holdingClasses,
      partnersRegister,
      holdingClassNames,
      bookDates,
      bookColumns,
      bookHeaders,
      bookComments,
      bookPartners,
      bookOperations,
      bookTotals,
      bookTotalPartners,
      bookOrder,
      bookDocuments,
      view,
      filtredMenuOptions,
      currentMenuOptions,
      currentViewOptions,
      isPartnerBookVisible,
      isAdmin,
      isReadOnly,
      user,
    },
    actions: {
      setView,
      handleExportTable,
      handleExportEquityStory,
      getHistoryTransactions,
      getPartnersPercentages,
      getSharesFromPartners,
    },
    isLoading,
    isLoadingPartnersRegister,
    isLoadingPartnerBook,
    isError,
  };
};
